import { apiSlice } from "@app/api/apiSlice";

export const orderManageApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loadAllOrdersAccToSchemeType: builder.query({
      query: (query) => `order?${query}`,
    }),
    loadOneOrderAccToSchemeType: builder.query({
      query: (id) => `order/${id}`,
    }),
    loadSchemeOptionsList: builder.query({
      query: ({ scheme_type, product_id }) =>
        `scheme?page=1&size=0&find_is_active=true&find_type=${scheme_type}&find_main_product=${product_id}`,
    }),
    loadCampaignOptionsList: builder.query({
      query: () =>
        `campaign?page=1&size=0&find_is_active=true`,
    }),
    // loadOrderAccToSchemeTypeSchemeDetails: builder.query({
    //   query: (scheme_id) => `scheme/${scheme_id}`,
    // }),
    placeOrder: builder.mutation({
      query: (body) => ({
        method: "POST",
        url: `order`,
        body,
      }),
    }),
    uploadFileIntoOrder: builder.mutation({
      query: (formData) => ({
        url: "order/upload",
        method: "POST",
        body: formData,
        headers: {
          "content-type": "multipart/form-data",
        },
      }),
    }),
    changeOrderStatus: builder.mutation({
      query: (body) => ({
        url: "order/update",
        method: "POST",
        body: body,
      }),
    }),
    loadRetailOptionsForOrderList: builder.query({
      query: () => `office?page=1&size=0&find_type=RETAILER`,
    }),
    loadAvailableMainProducts: builder.mutation({
      query: ({ scheme_type }) =>
        `product/offer?page=1&size=0&find_type=${scheme_type}&is_public=false`,
    }),
    updateCustomerInfoInOrder: builder.mutation({
      query: (body) => ({
        url: "order/data",
        method: "POST",
        body,
      }),
    }),

    updateOfficeInfoInOrder: builder.mutation({
      query: (body) => ({
        url: "order/update/office",
        method: "POST",
        body,
      }),
    }),

    updateMainProductInfoInOrder: builder.mutation({
      query: (body) => ({
        url: "order/update/product",
        method: "POST",
        body,
      }),
    }),

    updateBundleProductInfoInOrder: builder.mutation({
      query: (body) => ({
        url: "order/update/bundle_product",
        method: "POST",
        body,
      }),
    }),

    // find product using product_id;
    getProductFromProductId: builder.query({
      query: (product_id) => `product/product/${product_id}`,
    }),
    loadActiveCampaignOrderCount: builder.query({
      query: () => `order/active-campaign-count`,
    }),
  }),
  overrideExisting: true,
});

export const {
  useLoadAllOrdersAccToSchemeTypeQuery,
  useLoadOneOrderAccToSchemeTypeQuery,
  useLoadSchemeOptionsListQuery,
  useLoadCampaignOptionsListQuery,
  // useLoadOrderAccToSchemeTypeSchemeDetailsQuery,
  usePlaceOrderMutation,
  useUploadFileIntoOrderMutation,
  useLoadSchemeDropdownOrderQuery,
  useLoadRetailOptionsForOrderListQuery,
  useChangeOrderStatusMutation,
  useLoadAvailableMainProductsMutation,
  useUpdateCustomerInfoInOrderMutation,
  useGetProductFromProductIdQuery,
  useUpdateOfficeInfoInOrderMutation,
  useUpdateMainProductInfoInOrderMutation,
  useUpdateBundleProductInfoInOrderMutation,
  useLoadActiveCampaignOrderCountQuery,
} = orderManageApiSlice;

